const PRODUCTS = [
  {
    id: 'vpn',
    name: 'DELPAK VPN',
    tagline: 'Uncompromising Privacy',
    description:
      'Military-grade encryption that protects your digital identity across every network. DELPAK VPN ensures your data remains private, your connection stays secure, and your iOS device is shielded from external threats — no matter where you are.',
    features: [
      'AES-256 encryption protocol',
      'Zero-log privacy policy',
      'Global server network',
      'Automatic kill switch',
    ],
    image:
      'https://public.readdy.ai/ai/img_res/994d2eb39bbdfbbafa666d760bd3fd2d.jpg',
    accent: 'from-teal-500 to-emerald-600',
    badge: 'Security',
  },
  {
    id: 'cleaner',
    name: 'DELPAK Cleaner',
    tagline: 'Peak Performance',
    description:
      'Keep your iPhone running at its absolute best. DELPAK Cleaner intelligently identifies redundant files, optimizes storage, and ensures your device maintains peak performance — delivering a smooth, responsive iOS experience every day.',
    features: [
      'Smart junk file detection',
      'Duplicate photo removal',
      'Memory optimization',
      'Battery health insights',
    ],
    image:
      'https://readdy.ai/api/search-image?query=iPhone%2015%20Pro%20mockup%20displaying%20a%20minimalist%20cleaner%20app%20with%20circular%20progress%20chart%20and%20storage%20analysis%20interface%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography%2C%20light%20UI%20with%20teal%20accent%20colors%20visible%20on%20screen&width=600&height=700&seq=delpak-cleaner-004&orientation=portrait',
    accent: 'from-emerald-500 to-teal-600',
    badge: 'Performance',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="bg-gray-50 py-32 px-6">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-20">
          <div>
            <p className="text-teal-500 text-xs font-semibold uppercase tracking-[0.25em] mb-4">
              Our Products
            </p>
            <h2
              className="text-gray-900 text-5xl font-bold leading-tight"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Designed for
              <br />
              iOS Excellence
            </h2>
          </div>
          <p className="text-gray-400 text-base max-w-xs mt-4 md:mt-0 leading-relaxed text-right hidden md:block">
            Precision-crafted applications that integrate seamlessly with Apple&apos;s ecosystem.
          </p>
        </div>

        {/* Product cards */}
        <div className="flex flex-col gap-10">
          {PRODUCTS.map((product, index) => (
            <div
              key={product.id}
              className={`bg-white rounded-2xl overflow-hidden flex flex-col ${
                index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              }`}
            >
              {/* Image side */}
              <div className="md:w-2/5 h-80 md:h-auto relative overflow-hidden bg-gray-100 flex-shrink-0">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${product.accent} opacity-20`} />
              </div>

              {/* Content side */}
              <div className="flex-1 p-12 flex flex-col justify-center">
                <span className="inline-block text-teal-500 text-xs font-semibold uppercase tracking-[0.2em] mb-3">
                  {product.badge}
                </span>
                <h3
                  className="text-gray-900 text-4xl font-bold mb-2"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {product.name}
                </h3>
                <p className="text-teal-500 font-medium mb-6">{product.tagline}</p>
                <p className="text-gray-500 text-base leading-relaxed mb-8">
                  {product.description}
                </p>

                {/* Features */}
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {product.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-3">
                      <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-base" />
                      </span>
                      <span className="text-gray-600 text-sm">{feat}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
